// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"d1124fae","366":"bbced6c6","436":"e834f547","441":"15f59ef5","453":"e31fbc67","476":"f08f0848","550":"d4a58fb2","551":"eabbe30e","787":"6b4742a3","847":"6b2f8dc3"}[chunkId] + ".chunk.js";
};